import { environment } from '@/helpers/Environment';
export function availabilityThreshold(items, threshold = false) {
    if (threshold !== false && items.some((available) => available < threshold)) {
        return threshold;
    }
    return false;
}
export function capacityThreshold(days) {
    const availability = days.filter((day) => day.available !== undefined).map((day) => day.available);
    return availabilityThreshold(availability, environment.web.show_remaining_session_capacity_threshold);
}
export function showAvailability(capacityThreshold) {
    return capacityThreshold !== false && capacityThreshold > 0;
}
